import React from 'react';
import { computationDecimalScale, computationValueLength } from '../../../../common/helper';
import FormsyInputField from '../../../elements/FormsyInputField';
import FormFields from "../../formFields/computation.json";
const FINAL_LOAN_DETAILS = FormFields?.FINAL_LOAN_DETAILS;

const FinalLoanDetails = ({
    computationDetails,
    allfieldsReadonly,
    isRegeneratedFieldActive,
    financierId,
    handlePatternFormatChange,
    handleInputChange,
}) => {
    return <section className="loan-payment-sec">
        {FINAL_LOAN_DETAILS?.map(field => (
            <div className='form-filed col-md-12'>
                <div className="material">
                    <label className='form-label'>{field.label}</label>
                    <FormsyInputField
                        id={field.id}
                        name={field.name}
                        type={field.type}
                        value={computationDetails?.[field.name]}
                        placeholder=" "
                        onChange={
                            field.type === "number-format"
                                ? (data) => handlePatternFormatChange(data, field.name)
                                : handleInputChange
                        }
                        format={field.ApplyNumberformat ? field.format : ""}
                        validations={field.validations}
                        validationError={
                            computationDetails?.[field.name] ? field.validationError : ""
                        }
                        readOnly={field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name)}
                        required={field.required}
                        decimalScale={computationDecimalScale(financierId)}
                        valueLength={computationValueLength(financierId)}
                    />
                </div>
            </div>
        ))}
    </section>;
};

export default FinalLoanDetails;
